import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";

// Define a type for the slice state
export type AppConfState = {
  environment: "test" | "prep" | "prod";
  logEnabled: string;
  workflowEnabled: boolean;
  underMaintenance: boolean;
  captchaEnabled: boolean;
  captchaSiteKey: string;
  captchaProtectedSteps: string[];
  crossSelling: boolean;
};

// Define the initial state using that type
const initialState: AppConfState = {
  environment: "test",
  logEnabled: "false",
  workflowEnabled: true,
  underMaintenance: false,
  captchaEnabled: true,
  captchaSiteKey: "",
  captchaProtectedSteps: [],
  crossSelling: false,
};

export const AppConfSlice = createSlice({
  name: "appConf",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setAppConf: (
      _appConf: AppConfState,
      action: PayloadAction<AppConfState>
    ) => {
      return { ...action.payload };
    },
  },
});

export const { setAppConf } = AppConfSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectStatus = (state: RootState) => state;

export default AppConfSlice.reducer;
